import {
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_ERROR
} from "./actionTypes"

export const updateNotification = (notifications) => ({
  type: UPDATE_NOTIFICATION,
  payload: notifications
})

export const updateNotificationSuccess = (notifications) => ({
  type: UPDATE_NOTIFICATION_SUCCESS,
  payload: notifications
})

export const updateNotificationError = (error) => ({
  type: UPDATE_NOTIFICATION_ERROR,
  payload: error
})